import type React from "react";

export const StretchIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  const { width = 50, height = 50, color = "#6a33ff", ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 61.858 61.858"
      xmlSpace="preserve"
      {...restProps}
    >
      <title>Stretch icon</title>
      <g>
        <path
          d="M50.097.014c-9.917.874-17.235 5.824-21.501 12.98-2.859 3.584-8.57 14.526-10.647 20.254-3.766 7.123-7.05 15.598-9.62 23.238-1.571 4.672 5.483 7.72 7.063 3.027 1.922-5.716 4.244-11.896 6.868-17.631 2.604 5.828 5.25 11.637 8.091 17.354 2.202 4.438 8.828.546 6.634-3.877-2.925-5.885-5.642-11.864-8.319-17.863.034-.116.077-.229.113-.344.446.127.938.166 1.48.063L42.55 34.91c1.751-.329 2.422-2.245 2.146-3.779-.828-4.597-3.447-7.795-6.707-10.821-.484-1.646-2.098-3.102-3.889-4.549 3.631-5.87 9.559-9.056 17.275-9.736 3.938-.345 2.626-6.354-1.278-6.011zM35.173 26.143c1.013 1.054 1.875 2.163 2.526 3.447l-5.947 1.115c1-1.61 2.151-3.13 3.421-4.562z"
          fill={color}
          opacity="1"
          data-original="#010002"
        ></path>
        <circle
          cx="43.653"
          cy="15.635"
          r="5.275"
          fill={color}
          opacity="1"
          data-original="#010002"
        ></circle>
      </g>
    </svg>
  );
};
